import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ServiceDetailPageContainer } from './ServiceDetailPage';
import { FaPaperPlane } from 'react-icons/fa';
import { motion } from 'framer-motion';
import emailjs from '@emailjs/browser';

const ServiceImage = styled.img`
  max-width: 200px;
  height: auto;
  border-radius: 0;
  margin: 0.5rem 0 1rem 2rem;
  box-shadow: none;
  float: right;

  @media (max-width: 768px) {
    float: none;
    margin: 1rem auto;
    max-width: 80%;
    display: block;
  }
`;

const ContactSection = styled.section`
  padding: 4rem 2rem;
  background: linear-gradient(45deg, #00B4DB, #007bff);
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 250px;
  color: white;
  position: relative;
  overflow: hidden;
  margin-top: 8rem;
  border-radius: 20px;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 30%;
    height: 100%;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15), transparent);
    transform: skewX(-20deg) translateX(30%);
    transform-origin: top right;
    pointer-events: none;
    z-index: 0;
  }
`;

const ContactContent = styled.div`
  position: relative;
  z-index: 1;
  max-width: 600px;
  width: 100%;
`;

export const ContactTitle = styled.h2`
  color: #fff !important;
  margin-top: 0 !important;
`;

const ContactForm = styled.form`
  display: flex;
  gap: 1rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
`;

const ContactInput = styled.input`
  padding: 1rem 1.5rem;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  flex: 1;
  min-width: 200px;
  background: rgba(255, 255, 255, 0.9);
  color: #1f2937;

  &::placeholder {
    color: #6b7280;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
  }
`;

const SubmitButton = styled.button`
  background: #00B4DB;
  color: white;
  border: none;
  padding: 1rem 1.5rem;
  font-size: 1.2rem;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 180, 219, 0.2);

  &:hover {
    background: #007bff;
    transform: scale(1.02);
    box-shadow: 0 4px 12px rgba(0, 180, 219, 0.3);
  }

  svg {
    margin: 0;
  }
`;

function EmailMarketing() {
  const [formData, setFormData] = useState({
    name: '',
    phone: ''
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    if (name === 'phone') {
      const numbersOnly = value.replace(/[^\d]/g, '');
      if (numbersOnly.length <= 11) {
        setFormData({
          ...formData,
          [name]: numbersOnly
        });
      }
    } else {
      setFormData({
        ...formData,
        [name]: value
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.phone.length !== 11) {
      alert('Telefon numarası 11 haneli olmalıdır.');
      return;
    }

    try {
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        time: new Date().toLocaleString('tr-TR')
      };

      await emailjs.send(
        'service_771tgg7',
        'template_w676du8',
        templateParams,
        'xjG6_a9zdp6ZU1zHp'
      );

      alert('Başarılı');
      setFormData({ name: '', phone: '' });
    } catch (error) {
      alert('Bir hata oluştu');
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <ServiceDetailPageContainer>
      <h1>E-Posta Pazarlama</h1>
      <p>Hedef kitlenize ulaşan, etkili e-posta kampanyaları ile satışlarınızı artırıyoruz. Kişiselleştirilmiş içerikler ve stratejik gönderimlerle e-posta pazarlamanızın dönüşüm oranlarını yükseltiyoruz.</p>

      <ServiceImage src="/media/demirer-ajans-4.png" alt="E-Posta Pazarlama Görseli 1" />

      <h2>Neden E-Posta Pazarlama Önemlidir?</h2>
      <p>E-posta pazarlaması, hala en yüksek yatırım getirisi (ROI) sağlayan dijital pazarlama kanallarından biridir. Doğru stratejilerle uygulandığında, müşteri sadakatini artırır, potansiyel müşterileri satışa dönüştürür ve markanızla kişisel bir bağ kurmanızı sağlar.</p>

      <ServiceImage src="/media/demirer-ajans-5.png" alt="E-Posta Pazarlama Görseli 2" />

      <h3>Hizmetlerimiz Neleri Kapsar?</h3>
      <ul>
        <li><b>Strateji Oluşturma:</b> Hedef kitlenize ve iş hedeflerinize uygun e-posta pazarlama stratejileri geliştirme.</li>
        <li><b>Liste Yönetimi:</b> E-posta listenizi segmentlere ayırma, temizleme ve büyütme stratejileri.</li>
        <li><b>İçerik Oluşturma:</b> Açılış oranlarını, tıklama oranlarını ve dönüşümleri artıracak ilgi çekici ve kişiselleştirilmiş e-posta içerikleri yazma.</li>
        <li><b>Tasarım ve Şablon Geliştirme:</b> Markanızın kimliğine uygun, mobil uyumlu ve profesyonel e-posta şablonları tasarlama.</li>
        <li><b>Otomasyon ve Segmentasyon:</b> Müşteri yolculuğuna göre otomatik e-posta serileri (hoş geldiniz, terk edilmiş sepet, doğum günü vb.) oluşturma ve segmentasyon ile doğru mesajı doğru kişiye gönderme.</li>
        <li><b>A/B Testleri:</b> Farklı e-posta öğelerini test ederek en iyi performansı yakalama.</li>
        <li><b>Raporlama ve Analiz:</b> Kampanya performansını detaylı olarak izleme, analiz etme ve optimize etme.</li>
      </ul>

      <h2>E-Posta Pazarlama Hizmetlerimiz</h2>
      <p>E-posta pazarlama hizmetlerimiz, işletmenizin müşterileriyle etkili iletişim kurmasını sağlamak için tasarlanmıştır. Uzman ekibimiz, kampanya tasarımı, liste yönetimi ve performans analizi konularında profesyonel çözümler sunar.</p>
      <p>Kişiselleştirilmiş içerik ve veri odaklı stratejilerle, e-posta pazarlama kampanyalarınızın başarısını artırıyoruz. İşletmenizin müşteri ilişkilerini güçlendirmek için bize güvenebilirsiniz.</p>

      <ContactSection>
        <ContactContent>
          <ContactTitle>Sizi Arayalım</ContactTitle>
          <ContactForm onSubmit={handleSubmit}>
            <ContactInput 
              type="text" 
              name="name"
              placeholder="Adınız"
              value={formData.name}
              onChange={handleInputChange}
              required 
            />
            <ContactInput 
              type="tel" 
              name="phone"
              placeholder="Telefon Numaranız (11 Haneli)"
              value={formData.phone}
              onChange={handleInputChange}
              pattern="[0-9]*"
              inputMode="numeric"
              maxLength="11"
              minLength="11"
              required 
            />
            <SubmitButton
              type="submit"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <FaPaperPlane />
            </SubmitButton>
          </ContactForm>
        </ContactContent>
      </ContactSection>
    </ServiceDetailPageContainer>
  );
}

export default EmailMarketing; 